import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-fuzzily',
  templateUrl: './pdf-find-fuzzily.component.html',
  styleUrls: ['./pdf-find-fuzzily.component.css'],
})
export class PdfFindFuzzilyComponent {}
